import { apiGet } from "../ApiMethod";
import { setCampusData } from "../../mappers";
import { CheckValue } from "../../service";

export const getCampusList = async (params = {}, cancelToken = null) => {
  const response = await apiGet("_campuses", params, null, cancelToken);
  const campuses = CheckValue(response.data?.campuses) ? response.data.campuses : [];
  return {
    ...response,
    rowData: campuses.map(setCampusData),
  };
};
